import React from 'react';
import { PropTypes } from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import styles from './ConfirmActionModal.module.scss';

const ConfirmActionModal = ({ isOpen, onCancel, onConfirm, title, message, buttonComponent, buttonProps }) => {
  const ButtonComponent = buttonComponent;
  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>{title}</ModalHeader>
      <ModalBody className={styles.modalBody}>{message}</ModalBody>
      <ModalFooter>{ButtonComponent && <ButtonComponent {...buttonProps} onClick={onConfirm} />}</ModalFooter>
    </Modal>
  );
};

ConfirmActionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  buttonComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  buttonProps: PropTypes.object,
};

export { ConfirmActionModal };
